module.exports = __webpack_public_path__ + "img/FANSPORT.69e0e48b.svg";